/**
 * Network+ question bank
 * Schema: { id, domain, subdomain, stem, choices: string[], answer: number, explanation, difficulty }
 */
const NET = [
  {
    id: "NET-001",
    domain: "Network+",
    subdomain: "Ports & Protocols",
    stem: "Which port does HTTPS use by default?",
    choices: ["80", "123", "443", "110"],
    answer: 2,
    explanation: "HTTPS uses TCP 443.",
    difficulty: "easy"
  },
  {
    id: "NET-002",
    domain: "Network+",
    subdomain: "Ports & Protocols",
    stem: "Which protocol is a secure replacement for Telnet?",
    choices: ["FTP", "SSH", "SNMPv2c", "POP3"],
    answer: 1,
    explanation: "SSH (TCP 22) provides encrypted remote shell access.",
    difficulty: "easy"
  },
  {
    id: "NET-003",
    domain: "Network+",
    subdomain: "Ports & Protocols",
    stem: "Which protocol and port are used for DNS queries?",
    choices: ["DNS over TCP 53 only", "DNS over UDP 53 (and TCP 53 for zone transfers)", "DNS over UDP 67", "DNS over TCP 110"],
    answer: 1,
    explanation: "DNS uses UDP 53 for queries; TCP 53 mainly for zone transfers and large responses.",
    difficulty: "medium"
  },
  {
    id: "NET-004",
    domain: "Network+",
    subdomain: "Wireless Standards",
    stem: "Which 802.11 standard operates only in the 5 GHz band and supports very high throughput with MU-MIMO?",
    choices: ["802.11g", "802.11n", "802.11ac", "802.11b"],
    answer: 2,
    explanation: "802.11ac (Wi-Fi 5) is 5 GHz only and introduced MU-MIMO.",
    difficulty: "easy"
  },
  {
    id: "NET-005",
    domain: "Network+",
    subdomain: "Wireless Standards",
    stem: "How many non-overlapping channels are there typically in 2.4 GHz Wi-Fi (North America)?",
    choices: ["3 (1, 6, 11)", "4 (1, 5, 9, 13)", "6 (1, 3, 5, 7, 9, 11)", "11 total non-overlapping"],
    answer: 0,
    explanation: "Channels 1, 6, and 11 do not overlap in 2.4 GHz in NA.",
    difficulty: "easy"
  },
  {
    id: "NET-006",
    domain: "Network+",
    subdomain: "Cabling",
    stem: "Cat6a is commonly rated to support which maximum speed over 100 meters?",
    choices: ["100 Mbps", "1 Gbps", "10 Gbps", "40 Gbps"],
    answer: 2,
    explanation: "Cat6a is rated for 10GBASE-T up to 100 m.",
    difficulty: "easy"
  },
  {
    id: "NET-007",
    domain: "Network+",
    subdomain: "Fiber",
    stem: "Which fiber type uses a larger core and is typically used for shorter distances inside buildings?",
    choices: ["Single-mode fiber (SMF)", "Multimode fiber (MMF)", "Twinax", "Coaxial"],
    answer: 1,
    explanation: "MMF has a larger core (e.g., 50/62.5 µm) and is used for shorter runs.",
    difficulty: "easy"
  },
  {
    id: "NET-008",
    domain: "Network+",
    subdomain: "Fiber",
    stem: "Which common fiber connector is small-form-factor and often used in pairs?",
    choices: ["ST", "RJ-45", "LC", "BNC"],
    answer: 2,
    explanation: "LC is a compact, push-pull connector used widely in modern gear.",
    difficulty: "easy"
  },
  {
    id: "NET-009",
    domain: "Network+",
    subdomain: "Ethernet",
    stem: "1000BASE-T uses which cable and connector type?",
    choices: ["Fiber with LC", "Copper UTP with RJ-45", "Coax with BNC", "Fiber with ST"],
    answer: 1,
    explanation: "Gigabit Ethernet over copper uses RJ-45 and twisted-pair.",
    difficulty: "easy"
  },
  {
    id: "NET-010",
    domain: "Network+",
    subdomain: "IPv4",
    stem: "Which IPv4 range is reserved for APIPA?",
    choices: ["10.0.0.0/8", "169.254.0.0/16", "172.16.0.0/12", "192.168.0.0/16"],
    answer: 1,
    explanation: "APIPA is 169.254.0.0/16.",
    difficulty: "easy"
  },
  {
    id: "NET-011",
    domain: "Network+",
    subdomain: "IPv4",
    stem: "Which are RFC1918 private IPv4 ranges?",
    choices: [
      "10.0.0.0/8, 172.16.0.0/12, 192.168.0.0/16",
      "100.64.0.0/10 only",
      "169.254.0.0/16 and 127.0.0.0/8",
      "224.0.0.0/4 and 240.0.0.0/4"
    ],
    answer: 0,
    explanation: "Private ranges are 10/8, 172.16/12, and 192.168/16.",
    difficulty: "easy"
  },
  {
    id: "NET-012",
    domain: "Network+",
    subdomain: "IPv6",
    stem: "Which prefix denotes an IPv6 link-local address?",
    choices: ["fc00::/7", "fe80::/10", "2001::/16", "::1/128"],
    answer: 1,
    explanation: "Link-local is fe80::/10.",
    difficulty: "easy"
  },
  {
    id: "NET-013",
    domain: "Network+",
    subdomain: "IPv6",
    stem: "SLAAC primarily relies on which mechanism?",
    choices: ["DHCPv6 stateful", "Router Advertisements (ICMPv6)", "ARP broadcasts", "NAT64"],
    answer: 1,
    explanation: "SLAAC uses ICMPv6 Router Advertisements to build addresses.",
    difficulty: "medium"
  },
  {
    id: "NET-014",
    domain: "Network+",
    subdomain: "DHCP",
    stem: "What is the correct order of the DHCP DORA process?",
    choices: ["Discover, Offer, Request, Acknowledge", "Discover, Offer, Acknowledge, Request", "Request, Discover, Offer, Ack", "Offer, Discover, Request, Ack"],
    answer: 0,
    explanation: "DORA: Discover → Offer → Request → Acknowledge.",
    difficulty: "easy"
  },
  {
    id: "NET-015",
    domain: "Network+",
    subdomain: "DNS",
    stem: "Which DNS record maps a hostname to an IPv6 address?",
    choices: ["A", "AAAA", "CNAME", "MX"],
    answer: 1,
    explanation: "AAAA maps hostnames to IPv6 addresses.",
    difficulty: "easy"
  },
  {
    id: "NET-016",
    domain: "Network+",
    subdomain: "Routing",
    stem: "OSPF is best described as what type of routing protocol?",
    choices: ["Distance vector", "Link-state", "Path-vector", "Static"],
    answer: 1,
    explanation: "OSPF is a link-state IGP.",
    difficulty: "medium"
  },
  {
    id: "NET-017",
    domain: "Network+",
    subdomain: "Routing",
    stem: "BGP is primarily categorized as which type of protocol?",
    choices: ["Distance vector IGP", "Link-state IGP", "Path-vector EGP", "Static EGP"],
    answer: 2,
    explanation: "BGP is a path-vector Exterior Gateway Protocol.",
    difficulty: "medium"
  },
  {
    id: "NET-018",
    domain: "Network+",
    subdomain: "Switching",
    stem: "802.1Q is associated with which function?",
    choices: ["Wireless roaming", "VLAN trunking", "Port security", "DHCP snooping"],
    answer: 1,
    explanation: "IEEE 802.1Q is VLAN tagging on trunk links.",
    difficulty: "easy"
  },
  {
    id: "NET-019",
    domain: "Network+",
    subdomain: "Switching",
    stem: "Spanning Tree Protocol primarily prevents which issue?",
    choices: ["Broadcast storms and loops", "IP spoofing", "DNS cache poisoning", "Man-in-the-middle"],
    answer: 0,
    explanation: "STP prevents layer-2 loops that cause broadcast storms.",
    difficulty: "easy"
  },
  {
    id: "NET-020",
    domain: "Network+",
    subdomain: "Security",
    stem: "Which wireless security option is considered the most secure for modern deployments?",
    choices: ["WEP", "WPA (TKIP)", "WPA2 (AES)", "WPA3 (SAE)"],
    answer: 3,
    explanation: "WPA3-SAE is the current best practice where supported.",
    difficulty: "medium"
  },
  {
    id: "NET-021",
    domain: "Network+",
    subdomain: "Security",
    stem: "802.1X provides which capability?",
    choices: ["Routing between VLANs", "Port-based network access control", "Link encryption only", "DHCP service"],
    answer: 1,
    explanation: "802.1X (with EAP) authenticates devices/users before granting port access.",
    difficulty: "medium"
  },
  {
    id: "NET-022",
    domain: "Network+",
    subdomain: "Security",
    stem: "SNMPv3 adds which security improvements over v1/v2c?",
    choices: ["None—same as v2c", "Authentication and encryption", "ICMP rate limiting", "Port security"],
    answer: 1,
    explanation: "SNMPv3 supports auth and privacy (encryption).",
    difficulty: "medium"
  },
  {
    id: "NET-023",
    domain: "Network+",
    subdomain: "Management",
    stem: "Syslog severity levels range from 0 to 7. What is level 0?",
    choices: ["Alert", "Emergency", "Critical", "Debug"],
    answer: 1,
    explanation: "0=Emergency, 1=Alert, 2=Critical, …, 7=Debug.",
    difficulty: "medium"
  },
  {
    id: "NET-024",
    domain: "Network+",
    subdomain: "VPN",
    stem: "Which of the following is a suite used to secure IP at the network layer?",
    choices: ["TLS", "IPsec", "L2TP without encryption", "GRE only"],
    answer: 1,
    explanation: "IPsec provides authentication and encryption at layer 3.",
    difficulty: "easy"
  },
  {
    id: "NET-025",
    domain: "Network+",
    subdomain: "WAN",
    stem: "MPLS primarily operates between which OSI layers?",
    choices: ["1 and 2", "2 and 3", "3 and 4", "4 and 7"],
    answer: 1,
    explanation: "MPLS is often described as a layer 2.5 technology.",
    difficulty: "medium"
  },
  {
    id: "NET-026",
    domain: "Network+",
    subdomain: "Wireless",
    stem: "What antenna type provides a narrow, high-gain beam ideal for long-distance point-to-point links?",
    choices: ["Omnidirectional dipole", "Yagi", "Rubber duck", "Patch (panel)"],
    answer: 1,
    explanation: "Yagi or parabolic are common directional long-range antennas.",
    difficulty: "easy"
  },
  {
    id: "NET-027",
    domain: "Network+",
    subdomain: "Cabling",
    stem: "A TDR (Time Domain Reflectometer) is used to test what type of cabling primarily?",
    choices: ["Fiber optic only", "Coax only", "Twisted-pair copper", "All copper and fiber equally"],
    answer: 2,
    explanation: "TDRs are typically used for copper (OTDR for fiber).",
    difficulty: "medium"
  },
  {
    id: "NET-028",
    domain: "Network+",
    subdomain: "Cabling",
    stem: "What is the maximum segment length for 1000BASE-SX over MMF (approximate common spec)?",
    choices: ["100 m", "300–550 m", "2 km", "10 km"],
    answer: 1,
    explanation: "1000BASE-SX often supports up to ~550 m depending on fiber grade.",
    difficulty: "medium"
  },
  {
    id: "NET-029",
    domain: "Network+",
    subdomain: "IP Services",
    stem: "Which record type would you query in DNS to find the mail server for a domain?",
    choices: ["A", "CNAME", "MX", "TXT"],
    answer: 2,
    explanation: "MX records point to mail exchangers.",
    difficulty: "easy"
  },
  {
    id: "NET-030",
    domain: "Network+",
    subdomain: "Security",
    stem: "Port security on a switch typically mitigates which threat?",
    choices: ["DNS tunneling", "MAC flooding", "SQL injection", "ARP expiration"],
    answer: 1,
    explanation: "Port security limits MACs per port to prevent CAM table overflow attacks.",
    difficulty: "medium"
  },
  {
    id: "NET-031",
    domain: "Network+",
    subdomain: "NAT",
    stem: "PAT (Port Address Translation) allows many internal hosts to share a single public IP by doing what?",
    choices: ["Changing source IP only", "Changing source ports per session", "Changing destination MAC", "Blocking inbound SYN packets"],
    answer: 1,
    explanation: "PAT multiplexes multiple connections by mapping to unique source ports.",
    difficulty: "medium"
  },
  {
    id: "NET-032",
    domain: "Network+",
    subdomain: "QoS",
    stem: "Which field is commonly used for QoS marking in IP networks?",
    choices: ["DSCP", "TTL", "Window size", "MTU"],
    answer: 0,
    explanation: "DSCP (in the IP header) marks packets for QoS handling.",
    difficulty: "medium"
  },
  {
    id: "NET-033",
    domain: "Network+",
    subdomain: "OSI",
    stem: "At which OSI layer does a switch primarily operate?",
    choices: ["Layer 1", "Layer 2", "Layer 3", "Layer 4"],
    answer: 1,
    explanation: "Switches are layer-2 devices (MAC switching), though multilayer switches can route at L3.",
    difficulty: "easy"
  },
  {
    id: "NET-034",
    domain: "Network+",
    subdomain: "OSI",
    stem: "At which OSI layer does a router primarily operate?",
    choices: ["Layer 1", "Layer 2", "Layer 3", "Layer 7"],
    answer: 2,
    explanation: "Routers make forwarding decisions at the network layer (L3).",
    difficulty: "easy"
  },
  {
    id: "NET-035",
    domain: "Network+",
    subdomain: "Monitoring",
    stem: "What technology aggregates switch ports for higher throughput and redundancy?",
    choices: ["STP", "Port channel / LACP", "VLAN trunking", "PoE"],
    answer: 1,
    explanation: "LACP (802.1AX/802.3ad) bonds links in a port-channel.",
    difficulty: "medium"
  },
  {
    id: "NET-036",
    domain: "Network+",
    subdomain: "PoE",
    stem: "802.3af provides up to approximately how much power at the device?",
    choices: ["7 W", "15.4 W", "30 W", "60–90 W"],
    answer: 1,
    explanation: "802.3af ≈ 15.4 W (PoE). 802.3at ≈ 30 W (PoE+).",
    difficulty: "easy"
  },
  {
    id: "NET-037",
    domain: "Network+",
    subdomain: "Security",
    stem: "RADIUS primarily provides what function in a network?",
    choices: ["Content filtering", "AAA (centralized authentication, authorization, accounting)", "Routing updates", "DHCP relay"],
    answer: 1,
    explanation: "RADIUS centralizes AAA services.",
    difficulty: "medium"
  },
  {
    id: "NET-038",
    domain: "Network+",
    subdomain: "Wireless",
    stem: "Which technique reduces co-channel interference in dense Wi-Fi deployments?",
    choices: ["Increase power to max", "Use channel reuse plans and lower AP power", "Disable 5 GHz", "Use only channel 6"],
    answer: 1,
    explanation: "Careful channel planning and power tuning reduce interference.",
    difficulty: "medium"
  },
  {
    id: "NET-039",
    domain: "Network+",
    subdomain: "IPv4 Subnetting",
    stem: "What is the default subnet mask for a Class C IPv4 network?",
    choices: ["255.0.0.0", "255.255.0.0", "255.255.255.0", "255.255.255.252"],
    answer: 2,
    explanation: "Class C default mask is /24.",
    difficulty: "easy"
  },
  {
    id: "NET-040",
    domain: "Network+",
    subdomain: "IPv6",
    stem: "Which address is the IPv6 loopback address?",
    choices: ["::", "::1", "fe80::1", "2001::1"],
    answer: 1,
    explanation: "Loopback is ::1/128.",
    difficulty: "easy"
  },
  {
    id: "NET-041",
    domain: "Network+",
    subdomain: "Security",
    stem: "A reverse proxy primarily sits in front of which systems?",
    choices: ["Clients on the LAN", "Servers to protect and load-balance them", "WAN routers", "Switch backplanes"],
    answer: 1,
    explanation: "Reverse proxies front servers for protection, caching, and load distribution.",
    difficulty: "medium"
  },
  {
    id: "NET-042",
    domain: "Network+",
    subdomain: "Wireless Security",
    stem: "Which method is commonly used for open guest access while still presenting Terms of Use?",
    choices: ["WPA2-Enterprise", "Captive portal", "WEP", "802.1X"],
    answer: 1,
    explanation: "Captive portals present a web page for acceptance/auth before full access.",
    difficulty: "easy"
  },
  {
    id: "NET-043",
    domain: "Network+",
    subdomain: "Troubleshooting",
    stem: "Which tool would you use to check end-to-end path and latency hop by hop?",
    choices: ["ping", "traceroute / tracert", "nslookup", "netstat"],
    answer: 1,
    explanation: "Traceroute reveals each hop and round-trip times.",
    difficulty: "easy"
  },
  {
    id: "NET-044",
    domain: "Network+",
    subdomain: "Troubleshooting",
    stem: "If you suspect a duplex mismatch on a copper link, what symptom is most likely?",
    choices: ["No link light at all", "High collisions / late collisions and poor throughput", "Excessive CRC on fiber only", "DHCP failures only"],
    answer: 1,
    explanation: "Duplex mismatch causes collisions and poor performance.",
    difficulty: "medium"
  },
  {
    id: "NET-045",
    domain: "Network+",
    subdomain: "Security",
    stem: "Which wireless authentication model uses a RADIUS server?",
    choices: ["WPA2-Personal (PSK)", "WPA2-Enterprise (802.1X/EAP)", "WEP-Open", "MAC filtering only"],
    answer: 1,
    explanation: "WPA2-Enterprise leverages 802.1X with a RADIUS backend.",
    difficulty: "easy"
  },
  {
    id: "NET-046",
    domain: "Network+",
    subdomain: "Logging",
    stem: "On Linux, which file typically stores system messages when using rsyslog/syslog?",
    choices: ["/etc/hosts", "/var/log/messages or /var/log/syslog", "/var/log/auth.log only", "/var/log/dhcpd.log"],
    answer: 1,
    explanation: "General system logs commonly go to /var/log/messages or /var/log/syslog.",
    difficulty: "medium"
  },
  {
    id: "NET-047",
    domain: "Network+",
    subdomain: "Wireless",
    stem: "Band steering on dual-band APs aims to:",
    choices: ["Force all clients to 2.4 GHz", "Prefer 5 GHz capable clients to 5 GHz", "Disable 2.4 GHz entirely", "Increase transmit power automatically"],
    answer: 1,
    explanation: "Band steering nudges clients to 5 GHz for better performance.",
    difficulty: "medium"
  },
  {
    id: "NET-048",
    domain: "Network+",
    subdomain: "Interfaces",
    stem: "SFP vs SFP+: which is generally true?",
    choices: ["Both are 1 Gbps only", "SFP is 10 Gbps and SFP+ is 1 Gbps", "SFP is typically 1 Gbps; SFP+ supports 10 Gbps", "Neither supports fiber"],
    answer: 2,
    explanation: "SFP commonly for 1G; SFP+ for 10G.",
    difficulty: "easy"
  },
  {
    id: "NET-049",
    domain: "Network+",
    subdomain: "MTU",
    stem: "What is the typical Ethernet MTU for non-jumbo frames?",
    choices: ["512 bytes", "1500 bytes", "4096 bytes", "9000 bytes"],
    answer: 1,
    explanation: "Standard Ethernet MTU is 1500 bytes (without jumbo frames).",
    difficulty: "easy"
  },
  {
    id: "NET-050",
    domain: "Network+",
    subdomain: "Ports & Protocols",
    stem: "Which of the following port-to-service mappings is correct?",
    choices: ["RDP — TCP 3389", "SMB — TCP 23", "IMAP — TCP 25", "NTP — TCP 123"],
    answer: 0,
    explanation: "RDP uses TCP 3389. (SMB 445, IMAP 143/993, NTP UDP 123).",
    difficulty: "easy"
  }
  ,
  {
    id: "NET-051",
    domain: "Network+",
    subdomain: "Redundancy",
    stem: "HSRP or VRRP on routers primarily provides which capability?",
    choices: ["Virtual router redundancy with active/standby", "Automatic NAT translation", "Per-packet load balancing across WAN links", "DNS load balancing"],
    answer: 0,
    explanation: "HSRP/VRRP provide a virtual gateway IP with active/standby routers for failover; they present a single default gateway to hosts.",
    difficulty: "medium"
  },
  {
    id: "NET-052",
    domain: "Network+",
    subdomain: "IPv4",
    stem: "Which IPv4 range is reserved for multicast addresses?",
    choices: ["224.0.0.0/4", "169.254.0.0/16", "10.0.0.0/8", "172.16.0.0/12"],
    answer: 0,
    explanation: "IPv4 multicast addresses occupy 224.0.0.0 through 239.255.255.255 (224.0.0.0/4).",
    difficulty: "easy"
  },
  {
    id: "NET-053",
    domain: "Network+",
    subdomain: "DHCP",
    stem: "A DHCP relay (or 'ip helper-address') on a router is used to do what?",
    choices: ["Forward DHCP broadcast requests between subnets to a DHCP server", "Act as a DHCP server itself by default", "Provide DNS resolution for clients", "Translate MAC addresses"],
    answer: 0,
    explanation: "Routers do not forward broadcasts; a DHCP relay forwards client DHCP broadcasts to a centralized DHCP server on another subnet.",
    difficulty: "medium"
  },
  {
    id: "NET-054",
    domain: "Network+",
    subdomain: "Protocols",
    stem: "ARP (Address Resolution Protocol) primarily operates at which OSI layer?",
    choices: ["Layer 2 (Link)", "Layer 3 (Network)", "Layer 4 (Transport)", "Layer 1 (Physical)"],
    answer: 0,
    explanation: "ARP resolves IPv4 addresses to MAC addresses and sits between Layer 2 and Layer 3; it’s commonly classified as a link-layer protocol.",
    difficulty: "easy"
  },
  {
    id: "NET-055",
    domain: "Network+",
    subdomain: "Ports & Protocols",
    stem: "Which protocol uses UDP port 69?",
    choices: ["FTP", "TFTP", "SFTP", "SIP"],
    answer: 1,
    explanation: "TFTP uses UDP 69 and provides a simple, unsecured file transfer service often used by network devices for booting or config transfer.",
    difficulty: "easy"
  },
  {
    id: "NET-056",
    domain: "Network+",
    subdomain: "Architecture",
    stem: "Software-defined networking (SDN) separates which two planes to centralize control?",
    choices: ["Control plane and data plane", "Application plane and physical plane", "User plane and management plane", "Transport plane and session plane"],
    answer: 0,
    explanation: "SDN centralizes the control plane in controllers while switches/routers keep a simple data plane for forwarding, enabling programmability.",
    difficulty: "medium"
  },
  {
    id: "NET-057",
    domain: "Network+",
    subdomain: "Switching",
    stem: "LACP (IEEE 802.3ad) is commonly used to: ",
    choices: ["Aggregate multiple physical links into a single logical link for throughput and redundancy", "Encrypt traffic between switches", "Perform per-packet NAT", "Replace STP entirely"],
    answer: 0,
    explanation: "LACP groups links into a port-channel to increase bandwidth and provide redundancy; it works with consistent hashing to distribute flows.",
    difficulty: "medium"
  },
  {
    id: "NET-058",
    domain: "Network+",
    subdomain: "Troubleshooting",
    stem: "Path MTU discovery relies on which ICMP message when a packet is too large to forward?",
    choices: ["Destination Unreachable — Fragmentation needed", "Echo Reply", "Time Exceeded", "Redirect"],
    answer: 0,
    explanation: "When a router cannot forward a packet because it exceeds the next hop MTU and the DF bit is set, it returns ICMP Destination Unreachable (Fragmentation needed) so the sender can reduce packet size.",
    difficulty: "medium"
  }
];

export default NET;
